import { createContext } from 'react'

const GroomingAppointmentWizardContext = createContext()
export default GroomingAppointmentWizardContext
